import styled from "@emotion/styled";
import { colors, radius, spacing } from "../design-tokens";

export type ActionButtonProps = {
  variant?: "primary" | "secondary" | "ghost";
  size?: "small" | "medium";
  isActive?: boolean;
};

const variantStyles = {
  primary: {
    background: colors.primary,
    color: colors.background,
    border: "none",
    hover: {
      background: colors.primaryHover,
    },
  },
  secondary: {
    background: colors.surface,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    hover: {
      background: colors.surfaceHover,
    },
  },
  ghost: {
    background: "transparent",
    color: colors.primary,
    border: "none",
    hover: {
      background: colors.surfaceHover,
    },
  },
};

export const ActionButton = styled.button<ActionButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs}px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  border-radius: ${radius.sm}px;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  flex-shrink: 0;
  width: fit-content;

  /* Size variants */
  padding: ${(props) => {
    return props.size === "small"
      ? `${spacing.sm}px ${spacing.sm}px`
      : `${spacing.sm}px ${spacing.md}px`;
  }};

  /* Apply variant styles */
  ${(props) => {
    const variant = props.variant || "ghost";
    const styles = variantStyles[variant];

    return `
      background: ${props.isActive ? colors.surfaceHover : styles.background};
      color: ${styles.color};
      border: ${styles.border};
    `;
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Icon support */
  svg {
    width: 16px;
    height: 16px;
  }
`;
